import { IncognitoOffIcon } from './IncognitoOffIcon';

/**
 * author: nilsfast
 * id 26B94EEC-5090-4DF4-99FC-C4A90830720A
 * name incognito-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/incognito-off.svg
 * tags
 */
export const AnonymousOffIcon = IncognitoOffIcon;
export default AnonymousOffIcon